import React from 'react';
import PropTypes from 'prop-types';
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from 'react-share';

import {
  SocialShareEmail,
  SocialShareFacebook,
  SocialShareLinkedIn,
  SocialShareTwitter,
} from './Social';

// The four social/email share buttons, shared by the case study nav rail and
// the mobile hero. `size` is a Tailwind h/w pair for the icons.
const ShareLinks = ({ shareUrl, shareTitle, shareSummary, size = 'h-9 w-9' }) => (
  <>
    <LinkedinShareButton url={shareUrl} title={shareTitle} summary={shareSummary}>
      <SocialShareLinkedIn className={`rounded-sm ${size}`} aria-hidden="true" />
    </LinkedinShareButton>
    <FacebookShareButton url={shareUrl} hashtag="#AblerNordic">
      <SocialShareFacebook className={`rounded-sm ${size}`} aria-hidden="true" />
    </FacebookShareButton>
    <TwitterShareButton url={shareUrl} title={shareTitle} via="Abler_Nordic">
      <SocialShareTwitter className={`rounded-sm ${size}`} aria-hidden="true" />
    </TwitterShareButton>
    <EmailShareButton url={shareUrl} subject={shareTitle} body="Shared from the Abler Nordic website:">
      <SocialShareEmail className={`rounded-sm ${size}`} aria-hidden="true" />
    </EmailShareButton>
  </>
);

ShareLinks.propTypes = {
  shareUrl: PropTypes.string,
  shareTitle: PropTypes.string,
  shareSummary: PropTypes.string,
  size: PropTypes.string,
};

export default ShareLinks;
